// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_TLS","colBig":"styles_colBig__2so5j","colSmall":"styles_colSmall__3fKjq"};